import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomToggleButton from "../../../../components/CustomToggleButton";

export default function NotifSwitch() {
  const [active, setActive] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        mt: 1,
        border: "1px solid gray",
        borderRadius: "8px",
        padding: "12px",
        justifyContent: "space-between",
        backgroundColor: "background.default",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <CustomToggleButton
          status={active}
          handleToggle={(status) => setActive((prev) => !status)}
        />
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          اطلاع‌رسانی بارهای جدید
        </Typography>
      </Box>
    </Box>
  );
}
